import { createSeededRandom } from '../../seeded-random';
import type { GenerateFillLayoutOptions, TileLayoutResult } from '../tile-layout-types';

import { placeAxisAlignedGappedStrips } from './axis-aligned-gapped-strips-layout';
import { placeDiagonalBiasedWalls } from './diagonal-biased-walls-layout';
import { createFillLayoutContext, topUpAndFinalize } from './fill-layout-context';

/**
 * Mix of diagonal-biased wall lines plus axis-aligned gapped strips, then scatter top-up.
 * Combines angled wall lines with axis-aligned density for denser, less regular maps.
 */
export function generateAngledWallsAndStripsLayout(options: GenerateFillLayoutOptions): TileLayoutResult {
  const ctx = createFillLayoutContext(options);
  const angledFilled = placeDiagonalBiasedWalls(ctx);
  // Second pass uses a derived seed so strip placement stays deterministic but independent.
  const stripCtx = {
    ...ctx,
    rand: createSeededRandom(ctx.seed + 101)
  };
  const stripFilled = placeAxisAlignedGappedStrips(stripCtx);
  return topUpAndFinalize(ctx, 'angledWallsAndStrips', angledFilled + stripFilled);
}
